import axios from "axios";

export const ACTION_GET_CURRENT_USER_PENDING = 'ACTION_GET_CURRENT_USER_PENDING';
export const ACTION_GET_CURRENT_USER_SUCCESS = 'ACTION_GET_CURRENT_USER_SUCCESS';
export const ACTION_GET_CURRENT_USER_ERROR = 'ACTION_GET_CURRENT_USER_ERROR';

function fetchCurrentUserPending() {
    return {
        type: ACTION_GET_CURRENT_USER_PENDING
    }
}

function fetchCurrentUserSuccess(currentUser) {
    return {
        type: ACTION_GET_CURRENT_USER_SUCCESS,
        currentUser: currentUser
    }
}

function fetchCurrentUserError(error) {
    return {
        type: ACTION_GET_CURRENT_USER_ERROR,
        error: error
    }
}

function fetchCurrentUserAction() {
    axios.defaults.baseURL = window.location.origin;
    var url = '/api/User/Current';
    return dispatch => {
        dispatch(fetchCurrentUserPending());
        axios.get(url, { withCredentials: true })
            .then(res => res.data)
            .then(res => {
                dispatch(fetchCurrentUserSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(fetchCurrentUserError(error));
            })
    }
}

export default fetchCurrentUserAction;
